import { render, staticRenderFns } from "./SuggestedReceivingLocation.vue?vue&type=template&id=9509f0f0&scoped=true&"
import script from "./SuggestedReceivingLocation.vue?vue&type=script&lang=js&"
export * from "./SuggestedReceivingLocation.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedReceivingLocation.vue?vue&type=style&index=0&id=9509f0f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9509f0f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
